import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Store } from "../../Store";

export default function UnprotectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo, token } = state;
  
  if (token && userInfo) {
    const role = userInfo?.role;
    const normalizedRole = typeof role === "string" ? role.toLowerCase() : role?.name?.toLowerCase();
    if (normalizedRole === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }
  
  return children;
}
